window.addEventListener('DOMContentLoaded', () => {
    let people_wrapper = document.querySelector('.team-grid .people-wrapper');
    let team_filters = document.querySelectorAll('.team-grid [data-filter]');
    if (team_filters) {
        team_filters.forEach(filter => {
            filter.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelector('.team-grid .filters .active').classList.remove('active');
                filter.classList.add('active');
                people_wrapper.setAttribute('data-active', filter.getAttribute('data-filter'));
                AOS.refresh(); // This ensures that sections below the team section will load if a filter is applied that shortens the page
            })
        })
    }
})

window.addEventListener('DOMContentLoaded', () => {
    let people_wrapper = document.querySelector('.team-grid .people-wrapper');
    let people = document.querySelectorAll('.team-grid .person-wrapper');
    if (people.length > 0) {
        people.forEach(person => {
            person.addEventListener('click', (e) => {
                if (e.target.closest('.close') == null) {
                    let currActive = people_wrapper.querySelector('.person-wrapper.active');
                    if (currActive && currActive != e.target.closest('.person-wrapper')) {
                        currActive.classList.add('close');
                        setTimeout(function(e) {
                            currActive.classList.remove('active');
                            currActive.classList.remove('close');
                            currActive.setAttribute('style', '');
                        }, 400);
                    }
                    person.setAttribute('style', `--tooltip-left-pos: ${person.getBoundingClientRect().left - people_wrapper.getBoundingClientRect().left}px;height: ${person.querySelector('.person .info').getBoundingClientRect().height}px`)
                    person.classList.add('active');
                }
            })
            person.querySelector('.info').addEventListener('click', (e) => {
                if (person.classList.contains('active')) {
                    person.classList.add('close');
                    setTimeout(function(e) {
                        person.classList.remove('active');
                        person.classList.remove('close');
                        person.setAttribute('style', '');
                    }, 400);
                }
            })
            person.querySelector('.close').addEventListener('click', (e) => {
                person.classList.add('close');
                setTimeout(function(e) {
                    person.classList.remove('active');
                    person.classList.remove('close');
                    person.setAttribute('style', '');
                }, 400);
            })
        })

        window.addEventListener('click', function(e) {
            let currActive = people_wrapper.querySelector('.person-wrapper.active');
            if (!e.target.closest('.person-wrapper') && currActive) {
                currActive.classList.add('close');
                setTimeout(function(e) {
                    currActive.classList.remove('active');
                    currActive.classList.remove('close');
                    currActive.setAttribute('style', '');
                }, 400);
            }
        })

        // Auto-open bio if included in URI
        let uri = window.location.hash;
        if (uri) {
            let person = document.querySelector(`${uri}`);
            if (person) {
                person.click();
            }
        }
    }

})